import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
// open source
import { BlockPicker } from "react-color";
import fileDownload from "react-file-download";
// styles
import styles from "./styles";

class FormServiceName extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    serviceName: PropTypes.object,
    exportServiceName: PropTypes.func,
    createServiceName: PropTypes.func,
    updateServiceName: PropTypes.func,
    deleteServiceName: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      color: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.serviceName);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(serviceName) {
    this.setState({
      loading: false,
      name: serviceName ? serviceName.name : "",
      color: serviceName ? serviceName.color : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this serviceName, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteServiceName, close, refresh, serviceName } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteServiceName(serviceName.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "ServiceName has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async handleExport() {
    const { exportServiceName, serviceName } = this.props;
    const resp = await exportServiceName(serviceName.id);
    const json = resp.payload;
    if (json) {
      fileDownload(
        JSON.stringify(json, null, "\t"),
        `${serviceName.name}_${moment().format("YYYY-MM-DD HH:mm:ss")}.json`
      );
    }
  }

  async save() {
    const {
      updateServiceName,
      createServiceName,
      serviceName,
      refresh,
      close,
    } = this.props;

    const { name, color } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (serviceName) {
      resp = await updateServiceName(serviceName.id, {
        name,
        color,
      });
    } else {
      resp = await createServiceName({
        name,
        color,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: serviceName
          ? "ServiceName has been updated."
          : "ServiceName has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, serviceName, close } = this.props;

    const { name, loading, color } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {serviceName
                ? `${serviceName.name}`
                : "Let's Create a New ServiceName"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {serviceName
                  ? "To update the serviceName, fill the form below :"
                  : "To create a new serviceName, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name *"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <BlockPicker
                    color={color}
                    onChange={(c) => {
                      console.log(c);
                      this.setState({
                        color: c.hex,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {serviceName && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {serviceName ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormServiceName));
